import { Controller } from "stimulus";

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

export default class extends Controller {
  static values = {
    placement: String,
    theme: String,
    autoShowDelay: Number,
  };

  connect() {
    this.tippyInstances = [];
    this.initializeTippy();
  }

  disconnect() {
    this.tippyInstances.forEach((instance) => instance.destroy());
    this.tippyInstances = [];
  }

  initializeTippy() {
    const elements = this.element.querySelectorAll("[data-tippy-content]");

    if (elements.length === 0) {
      return;
    }

    const placement = this.hasPlacementValue ? this.placementValue : "top";
    const theme = this.hasThemeValue ? this.themeValue : "va";
    const autoShowDelay = this.hasAutoShowDelayValue
      ? this.autoShowDelayValue
      : 2000;

    this.tippyInstances = tippy(elements, {
      placement: placement,
      theme: theme,
    });

    if (autoShowDelay > 0) {
      setTimeout(() => {
        this.tippyInstances.forEach((instance) => {
          const element = instance.reference;
          const isVisible = element.offsetWidth > 0 && element.offsetHeight > 0;
          if (isVisible) {
            instance.show();
            instance.setProps({ trigger: "mouseenter focus" });
          }
        });
      }, autoShowDelay);
    }
  }
}
